import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthHeaders } from '../utils/auth';
import './RSSFeed.css';

function RSSFeed() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [feeds, setFeeds] = useState([]);

  useEffect(() => {
    loadFeeds();
  }, []);

  useEffect(() => {
    if (feeds.length > 0) {
      fetchArticles();
    } else {
      setLoading(false);
    }
  }, [feeds]);

  const loadFeeds = async () => {
    try {
      const response = await axios.get('/api/rss/feeds', {
        headers: getAuthHeaders()
      });
      setFeeds(response.data);
    } catch (error) {
      console.error('Error loading RSS feeds:', error);
      setFeeds([]);
    }
  };

  // Clean description by removing unwanted prefixes (fallback in case backend doesn't catch it)
  const cleanDescription = (description) => {
    if (!description) return '';
    
    const unwantedPrefix = 'Click the link below to listen to a recording of the text as you read it. &#160; ';
    const unwantedPrefixAlt = 'Click the link below to listen to a recording of the text as you read it. \u00A0';
    
    let cleaned = description.trim();
    
    if (cleaned.startsWith(unwantedPrefix)) {
      cleaned = cleaned.substring(unwantedPrefix.length).trim();
    } else if (cleaned.startsWith(unwantedPrefixAlt)) {
      cleaned = cleaned.substring(unwantedPrefixAlt.length).trim();
    }
    
    return cleaned;
  };

  const fetchArticles = async () => {
    try {
      const response = await axios.get('/api/rss/articles', {
        headers: getAuthHeaders()
      });
      // Get 8 random articles and clean descriptions
      const allArticles = (response.data || []).map(article => ({
        ...article,
        description: cleanDescription(article.description)
      }));
      const shuffled = [...allArticles].sort(() => 0.5 - Math.random());
      setArticles(shuffled.slice(0, 8));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching articles:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="rss-feed-section">
        <div className="rss-header">
          <h2 className="rss-title">LATEST NEWS</h2>
        </div>
        <div className="rss-loading">Loading articles...</div>
      </div>
    );
  }

  if (feeds.length === 0) {
    return (
      <div className="rss-feed-section">
        <div className="rss-header">
          <h2 className="rss-title">LATEST NEWS</h2>
        </div>
        <div className="rss-empty">
          <p>No RSS feeds configured.</p>
          <p style={{ fontSize: '12px', marginTop: '8px', opacity: 0.7 }}>
            Add RSS feeds in settings (⚙️) to see articles here.
          </p>
        </div>
      </div>
    );
  }

  if (articles.length === 0) {
    return (
      <div className="rss-feed-section">
        <div className="rss-header">
          <h2 className="rss-title">LATEST NEWS</h2>
        </div>
        <div className="rss-empty">
          No articles found. Check your RSS feed URLs in settings.
        </div>
      </div>
    );
  }

  return (
    <div className="rss-feed-section">
      <div className="rss-header">
        <h2 className="rss-title">LATEST NEWS</h2>
      </div>
      <div className="rss-articles-grid">
        {articles.map((article, index) => (
          <div key={index} className="rss-article" onClick={() => window.open(article.link, '_blank')}>
            {article.image ? (
              <div className="rss-article-image-container">
                <img 
                  src={article.image} 
                  alt={article.title || 'Article image'}
                  className="rss-article-image"
                  onError={(e) => {
                    // Fallback to icon if image fails to load
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="rss-article-icon" style={{ display: 'none' }}>📡</div>
              </div>
            ) : (
              <div className="rss-article-icon">📡</div>
            )}
            <div className="rss-article-content">
              <div className="rss-article-title">{article.title || 'Untitled'}</div>
              <div className="rss-article-description">
                {article.description || article.contentSnippet || 'No description available.'}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default RSSFeed;

